import React from 'react';
import { Copy, Edit3, Plus, Trash2 } from 'lucide-react';
import { useEditorStore } from '../store/editor';
import { CellSvg } from '../render/CellSvg';

export const BoardView: React.FC = () => {
  const project = useEditorStore((state) => state.project);
  const mutate = useEditorStore((state) => state.mutate);
  const setActiveCell = useEditorStore((state) => state.setActiveCell);
  const addCell = useEditorStore((state) => state.addCell);
  const duplicateCell = useEditorStore((state) => state.duplicateCell);
  const deleteCell = useEditorStore((state) => state.deleteCell);

  if (!project) return null;
  return (
    <main className="board-view">
      <header className="board-view-header">
        <div>
          <span className="eyebrow">Complete storyboard</span>
          <h1>{project.title}</h1>
        </div>
        <div className="board-controls">
          <label><span>Columns</span><input type="range" min={1} max={6} step={1} value={project.layout.columns} onChange={(event) => mutate((draft) => { draft.layout.columns = Number(event.target.value); })} /><output>{project.layout.columns}</output></label>
          <button type="button" className="secondary-button" onClick={addCell} disabled={project.cells.length >= 100}><Plus size={18} /> Add cell</button>
        </div>
      </header>
      <section className="board-grid" style={{ gridTemplateColumns: `repeat(${Math.min(project.layout.columns, project.cells.length + 1)}, minmax(240px, 1fr))` }}>
        {project.cells.map((cell, index) => (
          <article className="board-cell-card" key={cell.id}>
            <button type="button" className="board-cell-preview" onClick={() => setActiveCell(cell.id)} aria-label={`Edit ${cell.title}`}>
              <CellSvg project={project} cell={cell} preserveAspectRatio="xMidYMid meet" />
              <span className="board-cell-number">{String(index + 1).padStart(2, '0')}</span>
              <span className="board-cell-edit"><Edit3 size={18} /> Edit cell</span>
            </button>
            <div className="board-cell-caption">
              {project.layout.showTitles && <h2>{cell.title || `Scene ${index + 1}`}</h2>}
              {project.layout.showDescriptions && cell.description && <p>{cell.description}</p>}
              <div className="board-card-actions">
                <button type="button" className="icon-button" onClick={() => duplicateCell(cell.id)} title="Duplicate scene"><Copy size={16} /></button>
                <button type="button" className="icon-button danger" onClick={() => deleteCell(cell.id)} disabled={project.cells.length === 1} title="Delete scene"><Trash2 size={16} /></button>
              </div>
            </div>
          </article>
        ))}
        <button type="button" className="board-add-cell" onClick={addCell} disabled={project.cells.length >= 100}><Plus size={28} /><span>Add another scene</span></button>
      </section>
    </main>
  );
};
